<template>
  <v-row data-testid="empty-floor-plan-state">
    <v-col cols="12">
      <v-card class="empty-floor-plan-state__card text-center">
        <v-icon size="80" color="grey lighten-1">
          mdi-floor-plan
        </v-icon>
        <h2 class="mt-4 mb-2">
          {{ $t('empty.title') }}
        </h2>
        <p class="empty-floor-plan-state__description mb-4">
          {{ $mpt($t('empty.description')) }}
        </p>
        <v-btn color="primary" large data-testid="empty-floor-plan-upload-btn" @click="$emit('upload')">
          <v-icon left>
            mdi-upload
          </v-icon>
          {{ $t('empty.upload_button') }}
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<i18n lang="yaml">
ja:
  empty:
    title: 図面がまだ登録されていません
    description: 現場の図面をアップロードして、センサー配置を管理しましょう
    upload_button: 図面をアップロード
en:
  empty:
    title: No floor plans registered yet
    description: Upload a floor plan to manage sensor placement
    upload_button: Upload floor plan
</i18n>

<script>
export default {
  name: 'EmptyFloorPlanState',
};
</script>

<style scoped>
.empty-floor-plan-state__card {
  padding: 48px 24px;
  border-radius: 8px;
}

.empty-floor-plan-state__description {
  color: #9e9e9e;
}
</style>
